import { Icon, IconButton, Paper, Tooltip } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { IFilteringViewModel } from "../../_common/interface/table";
import { PageHeader } from "../../_components/header/page.header";
import { CommonTable } from "../../_components/table/common.table";
import { API_URL } from "../../_config/config.const";
import { splitWordOnCamelCase } from "../../_helpers/format.helper";
import { formFieldService } from "../../_services/formField.service";
import { tokenService } from "../../_services/token.service";
import { UserProfileUploadManageDrawer } from "./userProfile-uploadManageDrawer";
import { FileUploadSourceEnum } from "../../_common/enum/fileUploadSource.enum";
import { toastr } from "../../_components/toastr/toastr";
import { accountService } from "../../_services/accounts.service";


export function UserProfileUploadList(params: {}) {

    const { userId } = useParams<{ userId: string }>();
    const navigate = useNavigate();
    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 100, page: 0, order: 'desc', orderBy: '' });

    useEffect(() => {
        fetchData();
    }, [filter]);

    function fetchData() {
        setLoading(true);
        return formFieldService
            .getAllUploadsByUserId(userId)
            .then(
                (json) => {
                    setData(json);
                }
            )
            .finally(() => setLoading(false));
    }

    function generateReport(fileId: number, fileUploadSourceId: FileUploadSourceEnum) {
        tokenService.GetReportToken().then((data) => {
            var url = fileUploadSourceId == FileUploadSourceEnum.UserProfile ? "fileUpload" : "formField";
            return window.open(API_URL + "/" + url + "/GetUploadById/?token=" + data + "&userId=" + userId + "&fileId=" + fileId, "_blank");
        });
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [

            {
                accessorKey: 'fileUploadSourceId',
                header: 'Source',
                accessorFn: (rowData: any) => <>{FileUploadSourceEnum[rowData.fileUploadSourceId]}</>,
            },
            {
                accessorKey: 'fieldValue',
                header: 'Document'
            },
            {
                accessorKey: 'formFieldValueTypeName',
                header: 'Document Type',
                accessorFn: (rowData: any) => <>{splitWordOnCamelCase(rowData.formFieldValueTypeName)}</>,
            }
        ],
        [],
    );

    return (
        <>
            <PageHeader
                pageName="My Uploads"
                actionType="create"
                buttonName={"Upload File"}
                onClick={() => { navigate("Create") }}
            />
            <Paper>

                <CommonTable
                    columns={columns}
                    data={data}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    isLoading={isLoading}
                    onView={(d) => { generateReport(Number(d.id), d.fileUploadSourceId) }}
                    // onEdit={(d) => { FileUploadSourceEnum.UserProfile ? navigate("Manage/" + d) : toastr.info("Can't update form field upload") }}
                    actions={({ row, table }) =>
                        <>
                            <Tooltip title="Edit">
                                <IconButton
                                    color="primary"
                                    disabled={!(FileUploadSourceEnum.UserProfile == row.original.fileUploadSourceId) || !accountService.isAdmin}
                                    onClick={(d) => { (FileUploadSourceEnum.UserProfile == row.original.fileUploadSourceId) ? navigate("Manage/" + row.original.id) : toastr.info("Can't update form field upload") }}>
                                    <Icon>edit</Icon>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="View User">
                                <IconButton
                                    color="primary"
                                    onClick={(d: any) => { generateReport(Number(row.original.id), row.original.fileUploadSourceId) }}>
                                    <Icon>visibility</Icon>
                                </IconButton>
                            </Tooltip>
                        </>
                    }
                />
            </Paper>

            <Routes>
                <Route path="Create" element={<UserProfileUploadManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} />
                <Route path="Manage/:fileId" element={<UserProfileUploadManageDrawer emitOnSave={() => { navigate(""); fetchData(); }} emitOnClose={() => { navigate("") }} />} />

            </Routes>
        </>
    );
}